export const STUDENT_CATEGOREIS = {
  REVIEW_SCHOOL: 1,
  DOCUMENT: 2,
  OUTPUT_STANDARDS_NEWS: 3,
  ADMISSION_NEWS: 4,
  EXPERIENCE: 5,
};

export const STUDENT_CATEGOREIS_DATA = [
  {
    id: STUDENT_CATEGOREIS.REVIEW_SCHOOL,
    name:"Review về trường"
  },
  {
    id: STUDENT_CATEGOREIS.DOCUMENT,
    name:"Tài liệu học tập"
  },
  {
    id: STUDENT_CATEGOREIS.OUTPUT_STANDARDS_NEWS,
    name:"Thông báo tin tức - Chuẩn đầu ra"
  },
  {
    id: STUDENT_CATEGOREIS.ADMISSION_NEWS,
    name:"Thông báo tin tức - Thông tin tuyển sinh"
  },
  {
    id: STUDENT_CATEGOREIS.EXPERIENCE,
    name:"Kinh nghiệm viết CV, phỏng vấn"
  },
];
